import { Injectable } from '@angular/core';
import { AppService } from "../../core/services/app.service";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})

export class ScheduleService {
  constructor(public http: HttpClient) {
  }
  
  createSchedule(data) {
    return this.http.post(AppService.getApiUrl() + '/api/scheduledJobs/', data);
  }
  
  updateSchedule(data) {
    return this.http.put(AppService.getApiUrl() + '/api/scheduledJobs/' + data.id, data);
  }
  
  getScheduledJob(queryParams, options) {
    return this.http.get(AppService.getApiUrl() + '/api/scheduledJobs'+ queryParams, options);
  }
  
  deleteScheduledJob(id) {
    return this.http.delete(AppService.getApiUrl() + '/api/scheduledJobs/' + id);
  }
}
